import React, { useMemo } from 'react';
import { useEffect } from 'react';

import styled from 'styled-components';

const Index = ({ totalCount = 0, pageIndex, setPageIndex }) => {
  // 한 그룹에 표시할 페이지번호 개수
  const groupCount = 5;
  const pageSize = 10;

  // 현재 그룹의 시작 페이지번호
  const startPage = useMemo(() => {
    return parseInt(pageIndex / groupCount, 10) * groupCount + 1;
  }, [pageIndex, groupCount]);

  // 현재 그룹의 끝 페이지번호
  const endPage = useMemo(() => {
    let endPageNo = ((startPage - 1 + groupCount) / groupCount) * groupCount;
    if (endPageNo > totalCount) {
      endPageNo = totalCount;
    }
    return endPageNo;
  }, [startPage, groupCount, totalCount]);

  // 이전 그룹의 마지막 페이지
  const prevPage = useMemo(() => {
    if (startPage > groupCount) {
      return startPage - 1;
    }
    return 0;
  }, [startPage, groupCount]);

  // 다음 그룹의 첫 페이지
  const nextPage = useMemo(() => {
    if (endPage < totalCount) {
      return endPage + 1;
    }
    return 0;
  }, [endPage, totalCount]);

  // 페이지 번호 생성
  const pageList = [];
  for (let i = startPage; i <= endPage; i++) {
    if (i <= Math.ceil(totalCount / pageSize)) {
      pageList.push(i);
    }
  }

  const handleClickPageChange = currentPage => {
    // window.scrollTo({ left: 0, top: 0 });
    setPageIndex(currentPage);
  };

  return (
    //
    <PagingWrap>
      {prevPage > 0 ? (
        <PageButtonWrap
          onClick={event => {
            event.preventDefault();
            handleClickPageChange(prevPage - 1);
          }}
        >
          <PageButton>&lt;</PageButton>
        </PageButtonWrap>
      ) : null}
      {pageList?.map(item => {
        return (
          <PageButtonWrap
            key={item}
            onClick={event => {
              event.preventDefault();
              handleClickPageChange(item - 1);
            }}
          >
            <PageButton sameIndex={item - 1 === pageIndex}> {item}</PageButton>
          </PageButtonWrap>
        );
      })}
      {nextPage > 0 && Math.ceil(totalCount / pageSize) >= nextPage ? (
        <PageButtonWrap
          onClick={event => {
            event.preventDefault();
            handleClickPageChange(nextPage - 1);
          }}
        >
          <PageButton>&gt;</PageButton>
        </PageButtonWrap>
      ) : null}
    </PagingWrap>
  );
};

const PagingWrap = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 2rem;
  gap: 0 1rem;
`;

const PageButtonWrap = styled.div``;

const PageButton = styled.button`
  cursor: pointer;
  width: 100%;
  min-width: 3.5rem;
  height: 3.5rem;
  background-color: ${props => (props.sameIndex ? '#dedede' : 'white')};
  color: black;
  font-size:1.2rem ;
  /* color: ${props => (props.sameIndex ? 'white' : 'black')}; */
  font-weight: bold;
  border-radius: 2px;
`;

export default Index;
